import React from 'react';
import './query-thread-card.scss';
import { ConversationThread } from '@zonofi/zono-money-store';
import { TouchableOpacity } from '../../common';
import { Avatar, Divider } from '../../components';
import { ReactComponent as ArrowRightIcon } from '@zonofi/svg-icons/arrow_right.svg';
import moment from 'moment';
import { SVGS } from '@zonofi/seller-hub/assets';
import { TIMETOKEN_MULTIPLIER } from '../helper';

interface QueryThreadCardProps {
  thread: ConversationThread;
  onPress?: (thread: ConversationThread) => void;
  showDivider?: boolean;
}

function formatThreadTimeFromTimetoken(timetoken: string | number): string {
  const ms = Number(timetoken) / TIMETOKEN_MULTIPLIER;
  const d = new Date(ms);
  const dateStr = d.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
  });
  const timeStr = d
    .toLocaleTimeString('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    })
    .replace(/\s*(am|pm)/i, (_, m) => ' ' + m.toUpperCase());
  return `${dateStr} ${timeStr}`;
}

export const QueryThreadCard: React.FC<QueryThreadCardProps> = ({
  thread,
  onPress = () => {},
  showDivider = false,
}) => {
  return (
    <div className="query-thread__card-view">
      <TouchableOpacity
        className="query-thread__container"
        onPress={() => onPress?.(thread)}
      >
        {/* Avatar */}
        <Avatar
          id={thread?.channelId}
          title={thread?.title}
          size={34}
          style={{ marginRight: '12px' }}
        />

        {/* Content */}
        <div className="query-thread__content">
          <div className="query-thread__title font-semibold">
            {thread?.title}
          </div>
          <div className="query-thread__description font-regular">
            {thread?.channelName}
          </div>
          <div className="query-thread__time-view">
            <img src={SVGS.Clock} />
            <div className="query-thread__time font-regular">
              {thread?.startMessageTimetoken &&
                formatThreadTimeFromTimetoken(thread.startMessageTimetoken)}
              {thread?.startMessageTimetoken &&
                thread?.endMessageTimetoken &&
                ' to '}
              {thread?.endMessageTimetoken &&
                formatThreadTimeFromTimetoken(thread.endMessageTimetoken)}
            </div>
          </div>
        </div>

        {/* Arrow */}
        <div>
          <ArrowRightIcon
            width={20}
            height={20}
            color="#8C8C8C"
            style={{ marginRight: '6px' }}
          />
        </div>
      </TouchableOpacity>

      {showDivider && <Divider className="query-thread__divider" />}
    </div>
  );
};
